import { enqueueSnackbar } from '~/utils/notifications';
import { SkipReason, SkipReport } from './FileHandler';

const NAMES_TO_SHOW = 3;

function formatNames(names: string[]): string {
    if (names.length <= NAMES_TO_SHOW) {
        return names.join(', ');
    }
    const shown = names.slice(0, NAMES_TO_SHOW).join(', ');
    const extra = names.length - NAMES_TO_SHOW;
    return `${shown}, +${extra} more`;
}

function groupByReason(report: SkipReport): Map<SkipReason, string[]> {
    const groups = new Map<SkipReason, string[]>();
    for (const entry of report.skips) {
        const list = groups.get(entry.reason) ?? [];
        list.push(entry.fileName);
        groups.set(entry.reason, list);
    }
    return groups;
}

export function emitSkipReportToasts(report: SkipReport): void {
    if (report.skips.length === 0) {
        return;
    }
    const groups = groupByReason(report);
    const examined = report.examined;

    const unrecognized = groups.get('unrecognized-extension');
    if (unrecognized && unrecognized.length > 0) {
        const summary =
            `${unrecognized.length} of ${examined} files skipped: ` +
            `unrecognized extension`;
        const suffix = 'Supported: .dcm, .dcm.gz, .zip.';
        // The user-facing toast lists filenames (PHI) so the user can locate
        // the skipped files; `logMessage` drops the names to keep the console
        // mirror in WarningSnackbarContent PHI-free.
        enqueueSnackbar(
            `${summary} (${formatNames(unrecognized)}). ${suffix}`,
            { variant: 'warning', logMessage: `${summary}. ${suffix}` }
        );
    }

    const unimportable = groups.get('unimportable-dicom');
    if (unimportable && unimportable.length > 0) {
        const summary =
            `${unimportable.length} of ${examined} files skipped: ` +
            `could not be imported as DICOM`;
        enqueueSnackbar(`${summary} (${formatNames(unimportable)}).`, {
            variant: 'warning',
            logMessage: `${summary}.`,
        });
    }
}
